"use client";

import type { GraphQLAuthMode } from "@aws-amplify/core/internals/utils";
import { generateClient } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

export async function getAmplifyGraphQLClient(): Promise<any> {
  const s = await fetchAuthSession();
  const t = s.tokens?.idToken?.toString();
  const client = generateClient({
    authToken: t,
    authMode: process.env
      .NEXT_PUBLIC_AWS_APPSYNC_AUTHENTICATIONTYPE as GraphQLAuthMode,
  });

  return client;
}
